import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import './style.css';

const identificacion = [
  {
    label: "Credencial para votar",
    value: "credencial para votar",
  },
  {
    label: "Pasaporte",
    value: "pasaporte",
  },
  {
    label: "Documento migratorio",
    value: "documento migratorio",
  },
];

function Pantalla14() {

  const [blContinue, setBlContinue] = useState(false);
  const [txtSelect, setTxtSelect] = useState('');
  const navigate = useNavigate();

  const onContinueGetInformation = async () => {

    if (txtSelect === 'credencial para votar') {
      localStorage.setItem("typeOfId", "ine");
      navigate("/AppIncode", {
        state: {
          rutaContinue: "/PantallaBase22",
          typeCredential: "ine"
        }
      });
    } else if (txtSelect === 'pasaporte') {
      localStorage.setItem("typeOfId", "pasaporte");
      navigate("/AppIncodePasaporte", {
        state: {
          rutaContinue: "/PantallaBase1Pass"
        }
      });
    }
  };

  const handleChange = async (selectedOption) => {

    const setSelectedOption = selectedOption.value;
    setTxtSelect(setSelectedOption);

    if (setSelectedOption === 'credencial para votar' ||
      setSelectedOption === 'pasaporte') {
      setBlContinue(true);
    } else {
      setBlContinue(false);
    }

  };

  const style = {
    control: (base) => ({
      ...base,
      height: "52px !important",
      borderRadius: "0.375rem !important",
      boxShadow: "none !important",
      borderColor: "#c4cbd1 !important",
      "&:hover": {
        borderColor: "#c4cbd1 !important"
      }
    }),
  };

  return (
    <>
      <div className="containerInfo_P2">
        <div className="containerIdent_P2">
          <p className="txtNat_P14">Documento de Identificación</p>
          <Select
            styles={style}
            options={identificacion}
            onChange={handleChange}
            formatOptionLabel={identificacion}
            placeholder="Seleccionar documento"
          />
          <hr className="line" />
          {!blContinue ? (
            <>
              {/* <div className="spaceButton14_line" /> */}
              <button className="btnVer_P3">
                <span className="txtVer_P3">Continuar</span>
              </button>
            </>
          ) : (
            <>
              {/* <div className="spaceButton14_line" /> */}
              <button
                className="btnVer_P14OK"
                onClick={onContinueGetInformation}
              >
                <span className="txtVer_P14OK">Continuar</span>
              </button>
              <br />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Pantalla14;
